/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Remove_LinkInputs */

const en_common_editor_remove_link = /** @type {(inputs: Common_Editor_Remove_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove link`)
};

const zh_common_editor_remove_link = /** @type {(inputs: Common_Editor_Remove_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除链接`)
};

/**
* | output |
* | --- |
* | "Remove link" |
*
* @param {Common_Editor_Remove_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_remove_link = /** @type {((inputs?: Common_Editor_Remove_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Remove_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_remove_link(inputs)
	return zh_common_editor_remove_link(inputs)
});
export { common_editor_remove_link as "common.editor.remove_link" }